export enum ViewerMode {
    PDF,
    Native,
    NativeOptional
}

export enum OverlayMode {
    Off,
    View,
    Print
}



// WEBPACK FOOTER //
// ./src/app/document-hitlist/models/enums.ts